import React from "react";

import ReportList from "./ReportList";

const LeadReportPage = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <h3>Báo cáo khách hàng tiềm năng</h3>
        <ReportList />
      </div>
    </React.Fragment>
  );
};

export default LeadReportPage;
